import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import achievableIcon from 'src/public/img/high-five.svg';
import measurableIcon from 'src/public/img/illustration-business-plan.svg';
import specificIcon from 'src/public/img/illustration-goals.svg';
import relevantIcon from 'src/public/img/undraw-studying-s-3-l-7.svg';
import timeBoundIcon from 'src/public/img/undraw_time_management_30iu.svg';

import { StepButtons } from 'src/modules/programs/components/StepButtons';
import { StepModal } from 'src/modules/programs/components/StepModal';
import { TipCard } from 'src/modules/programs/components/TipCard';
import * as S from 'src/modules/programs/stepComponents/styles';

import { GoalSettingTipsContent } from '../components/GoalSettingTips';

const goalTipsIcons = [specificIcon, measurableIcon, achievableIcon, relevantIcon, timeBoundIcon];

interface GoalSettingTips {
    description: string;
    disadvise: string;
    advise: string;
}

interface GoalTips {
    title: string;
    icon: string;
    list: GoalSettingTips;
}

interface State {
    isModalOpen: boolean;
}

interface StateProps {
    goToPreviousStep: () => void;
    goToNextStep: () => void;
}

type Props = WithTranslation & StateProps;

class GoalSettingTipsStepContainer extends React.Component<Props, State> {
    public state: State = {
        isModalOpen: false,
    };

    public handleToggleModal = () => {
        this.setState(state => ({ isModalOpen: !state.isModalOpen }));
    };

    public render(): JSX.Element {
        const { t } = this.props;

        const goalTips: GoalTips[] = t('week-2.goal-setting-tips.goalTips', {
            returnObjects: true,
        });

        return (
            <>
                <S.ContentRow>
                    <S.ContentColumn>
                        <S.StepHeading>{t('week-2.goal-setting-tips.title')}</S.StepHeading>
                        <S.StepDescription small>
                            <S.Strong>{t('week-2.goal-setting-tips.description.1')}</S.Strong>
                            {t('week-2.goal-setting-tips.description.2')}
                            <S.Strong>{t('week-2.goal-setting-tips.description.3')}</S.Strong>
                        </S.StepDescription>
                    </S.ContentColumn>
                </S.ContentRow>
                <S.ContentRow type="flex">
                    {goalTips.map((goalTip, index: number) => (
                        <TipCard
                            key={goalTip.title}
                            iconUrl={goalTipsIcons[index]}
                            title={goalTip.title}
                            children={<GoalSettingTipsContent list={[goalTip.list]} />}
                        />
                    ))}
                </S.ContentRow>
                <StepModal
                    centeredText
                    isVisible={this.state.isModalOpen}
                    onCancel={this.handleToggleModal}
                    nextStep={this.props.goToNextStep}
                >
                    <S.ModalIcon iconUrl={relevantIcon} />
                    <S.ModalTitle>{t('week-2.goal-setting-tips-modal.title')}</S.ModalTitle>
                    <S.ModalText>{t('week-2.goal-setting-tips-modal.text')}</S.ModalText>
                </StepModal>
                <StepButtons
                    onPreviousClick={this.props.goToPreviousStep}
                    onNextClick={this.handleToggleModal}
                    hasNextStep
                />
            </>
        );
    }
}

export const GoalSettingTipsStep = withTranslation('cbt')(GoalSettingTipsStepContainer);
